import { render } from "./ConfirmMembershipDialog.vue?vue&type=template&id=4b95a41e"
import script from "./ConfirmMembershipDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmMembershipDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__